import { Reducer } from 'redux';
import { GroupsState, GroupsTypes } from '../../types/groups.types';

const INITIAL_STATE: GroupsState = {
    items: [],
    current: null,
    paging: {
        total_items: 0,
        total_pages: 1
    },
    loading: false,
    error: false,
    message: ''
};

const reducer: Reducer<GroupsState> = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GroupsTypes.SEARCH_GROUPS_REQUEST:
            return { ...state, loading: true };
        case GroupsTypes.SEARCH_GROUPS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                items: action.payload.items,
                paging: action.payload.paging,
                message: action.payload.message
            };
        case GroupsTypes.SEARCH_GROUPS_FAILURE:
            return {
                ...state,
                loading: false,
                error: true,
                items: [],
                paging: {
                    total_items: 0,
                    total_pages: 1
                },
                message: ''
            };
        case GroupsTypes.TAKE_GROUP_REQUEST:
            return {
                ...state,
                loading: true
            };
        case GroupsTypes.TAKE_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                current: action.payload.group,
                message: action.payload.message
            };
        case GroupsTypes.TAKE_GROUP_FAILURE:
            return {
                ...state,
                loading: false,
                error: true,
                current: null,
                message: ''
            };
        case GroupsTypes.SAVE_GROUP_FAILURE: {
            return {
                ...state,
                error: true,
                message: ''
            };
        }
        default:
            return state;
    }
};

export default reducer;
